import { API, authClient } from "../index";

export const getFormResponses = () => {
	return authClient().get(`${API}/form-response?getDisabled=true`);
};

export const getFormResponseById = (id) => {
	return authClient().get(`${API}/form-response/${id}`);
};

export const getFormResponsesByUserId = (userId) => {
	return authClient().get(`${API}/form-response/user/${userId}`);
}

export const deleteFormResponse = (id) => {
	return authClient().delete(`${API}/form-response/${id}`);
};

export const postFormResponse = async (form) => {
	return authClient().post(`${API}/form-response`, form);
};

export const updateFormResponse = async (id, form) => {
	return authClient().put(`${API}/form-response/${id}`, form);
};

export const changeStatusFormResponse = async (id, active) => {
	return authClient().put(`${API}/form-response/change-status/${id}`, {
		active,
	});
};
